import { render, staticRenderFns } from "./DatasetTree.vue?vue&type=template&id=7bc7f3fa&scoped=true"
import script from "./DatasetTree.vue?vue&type=script&lang=js"
export * from "./DatasetTree.vue?vue&type=script&lang=js"
import style0 from "./DatasetTree.vue?vue&type=style&index=0&id=7bc7f3fa&scoped=true&lang=css"
import style1 from "./DatasetTree.vue?vue&type=style&index=1&id=7bc7f3fa&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc7f3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc7f3fa')) {
      api.createRecord('7bc7f3fa', component.options)
    } else {
      api.reload('7bc7f3fa', component.options)
    }
    module.hot.accept("./DatasetTree.vue?vue&type=template&id=7bc7f3fa&scoped=true", function () {
      api.rerender('7bc7f3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetTree.vue"
export default component.exports